<template>
  <a
    data-testid="download-button"
    class="download-button"
    :href="url"
    rel="noopener noreferrer"
    target="_blank"
    download
    @click="trackDownloadButton"
  >
    <BaseIcon
      class="icon"
      icon="ic_download"
      :colors="NebraskaColors.elementPrimary"
      aria-hidden="true"
    />
    <BaseText as="span">{{ computedTitle }}</BaseText>
  </a>
</template>

<script lang="ts">
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { BaseIcon, BaseText } from '@warrenbrasil/nebraska-web';

@Component({
  components: { BaseIcon, BaseText }
})
export default class DownloadButton extends Vue {
  @Prop({ type: String, required: true })
  readonly url!: string;

  @Prop({ type: String })
  readonly title!: string;

  public get NebraskaColors() {
    return NebraskaColors;
  }

  public get computedTitle() {
    return this.title ? this.title : this.url.split('/').pop();
  }

  @Emit('track-download-button')
  trackDownloadButton() {
    return this.computedTitle;
  }
}
</script>

<style lang="less" scoped>
.download-button {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: @size-spacing-x350 @size-spacing-x500;
  text-decoration: none;
  border-radius: 8px;
  background: @background-primary;
  transition: background 0.2s cubic-bezier(0.55, 0, 0.1, 1);

  &:hover {
    background: @background-hover;
  }
}

.icon {
  margin-right: @size-spacing-x400;
  line-height: 0;
}
</style>
